
export default {
    images: {}
}
